
export default {
    images: {}
}
